// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 600px) {\nh1[data-v-5d1e9bee] {\n    font-size: 1.25rem;\n}\n.v-card[data-v-5d1e9bee] {\n    padding: 12px !important;\n}\n.v-btn[data-v-5d1e9bee] {\n    min-width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
